@if (!showAsChip()) {
	<form-field-label [labelTranslateKey]="'priority'" />
	<mat-form-field appearance="outline" class="priority-container">
		<mat-select
			[formControl]="priority"
			[placeholder]="placeholder() | translate"
			hideSingleSelectionIndicator="true"
			class="hidden-mat-select-arrow"
		>
			<mat-select-trigger class="selected-priority">
				{{ priority?.value?.text | translate }}
				<div class="icons">
					<mat-icon [ngClass]="priority.value.text" svgIcon="priority-circle" />
					@if (showRemoveButton() && priority.value?.text !== 'none') {
						<mat-icon
							class="cursor-pointer"
							svgIcon="close"
							(click)="priority.setValue({ level: null, text: 'none' })"
						/>
					}
				</div>
			</mat-select-trigger>

			@for (priority of defaultPriorities; track priority.level) {
				<mat-option [value]="priority" class="priority-option"
					>{{ priority.text | translate }}
					<mat-icon [ngClass]="priority.text" svgIcon="priority-circle" />
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
} @else {
	<mat-chip [ngClass]="priority.value?.text" [matMenuTriggerFor]="priorityMenu">
		<div class="priority-chip">
			<mat-icon [ngClass]="priority.value.text" svgIcon="priority-circle" />
			{{ priority.value?.text | translate }}
		</div>
	</mat-chip>

	<mat-menu #priorityMenu="matMenu" class="priority-menu">
		@for (priorityItem of defaultPriorities; track priorityItem.level) {
			<button mat-menu-item (click)="priority.setValue(priorityItem)">
				{{ priorityItem.text | translate }}
				<mat-icon [ngClass]="priorityItem.text" svgIcon="priority-circle" />
			</button>
		}
	</mat-menu>
}
